import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@env/environment';
import {MessageService} from 'primeng/api';
import {PrintEscPos} from '@app/domain/print-esc-pos';
import {PrintPdf} from '@app/domain/print-pdf';
import {PrintTextLine} from '@app/service/restaurant.service';


@Injectable({
    providedIn: 'root'
})
export class PrintService {

    private wsEndpoint: string = environment.wsEndpointPrint;

    constructor(private http: HttpClient,
                private messageService: MessageService
            ) {
    }

    printCoffe(data) {
        const options = {
            headers: {hideLoader: 'S', isPrinting: 'S'}
        };
        this.http.post<any>(`${this.wsEndpoint}/print-coffe`, this.getPrintPayload(data), options).subscribe(resp => {
            if (resp.printed) {
                this.messageService.add({severity: 'success', summary: data.printerName, detail: resp.message});
            } else {
                this.showPrintFailure(data, 'Error al imprimir: ' + resp.message, true);
            }
        }, error => {
            this.showPrintFailure(data, 'Ocurrió un error al imprimir');
        });
    }

    printCoffeLocalEscPos(baseUrl, data: PrintEscPos) {
        const payload = this.getPrintPayload(data);
        console.log('Orden de impresion EscPos', baseUrl, payload);
        this.http.post<any>(`${baseUrl}/api/print-escpos`, payload).subscribe(resp => {
            this.messageService.add({severity: 'success', summary: data.printerName, detail: 'Impreso correctamente'});
        }, error => {
            this.showPrintFailure(data, 'Ocurrió un error al imprimir');
        });
    }

    printCoffeLocalPdf(baseUrl, data: PrintPdf) {
        const payload = this.getPrintPayload(data);
        console.log('Orden de impresion Pdf', baseUrl, payload);
        this.http.post<any>(`${baseUrl}/api/print-pdf`, payload).subscribe(resp => {
            this.messageService.add({severity: 'success', summary: data.printerName, detail: 'Impreso correctamente'});
        }, error => {
            this.showPrintFailure(data, 'Ocurrió un error al imprimir');
        });
    }

    private showPrintFailure(data: any, defaultDetail: string, warning = false) {
        if (data?.restaurantContext) {
            const printerLabel = data.printerName ? ` en ${data.printerName}` : '';
            this.messageService.add({
                severity: 'warn',
                summary: `No se pudo imprimir${printerLabel}`,
                detail: data.printFailureMessage ||
                    'El registro se guardó correctamente. Revisa la impresora y vuelve a intentarlo.',
                life: 6000
            });
            return;
        }
        this.messageService.add({
            severity: warning ? 'warn' : 'error',
            summary: data.printerName,
            detail: defaultDetail
        });
    }

    private getPrintPayload<T extends object>(data: T): T {
        const payload = {...data};
        delete payload['restaurantContext'];
        delete payload['printFailureMessage'];
        return payload;
    }
}
